import { defineMessages, MessageDescriptor } from "react-intl"

const reimbursementCategoryNameMessages: Record<string, MessageDescriptor> = defineMessages({
  ADOPTION_AND_GC: {
    defaultMessage: "Adoption and gestational surrogacy"
  },
  ADOPTION_AND_GC_EXPENSES: {
    defaultMessage: "Adoption and gestational surrogacy expenses"
  },
  ADOPTION: {
    defaultMessage: "Adoption"
  },
  ADOPTION_EXPENSES: {
    defaultMessage: "Adoption expenses"
  },
  DEFAULT: {
    defaultMessage: "Default"
  },
  FERTILITY: {
    defaultMessage: "Fertility care"
  },
  FERTILITY_AND_PRESERVATION: {
    defaultMessage: "Fertility care and preservation"
  },
  GAC: {
    defaultMessage: "Gender-affirming care"
  },
  GC: {
    defaultMessage: "Gestational surrogacy"
  },
  GC_EXPENSES: {
    defaultMessage: "Gestational surrogacy expenses"
  },
  M_LT: {
    defaultMessage: "Menopause and low testosterone"
  },
  M_LT_GAC: {
    defaultMessage: "Menopause, low testosterone, and gender-affirming care"
  },
  MEDICATION: {
    defaultMessage: "Medications"
  },
  OTHER: {
    defaultMessage: "Other"
  },
  OTHER_EXPENSES: {
    defaultMessage: "Other expenses"
  },
  PREGNANCY: {
    defaultMessage: "Pregnancy and postpartum"
  },
  PREGNANCY_EXPENSES: {
    defaultMessage: "Pregnancy and postpartum expenses"
  },
  PREGNANCY_M_LT: {
    defaultMessage: "Pregnancy and postpartum, menopause, and low testosterone"
  },
  PRESERVATION: {
    defaultMessage: "Fertility preservation"
  },
  QME: {
    defaultMessage: "Qualified medical expenses"
  },
  FERTILITY_M_LT: {
    defaultMessage: "Fertility, menopause, and low testosterone"
  },
  FERTILITY_GC_ADOPTION: {
    defaultMessage: "Fertility, gestational surrogacy, and adoption"
  }
})

export function getCategoryName(category: string, hasQmeCategory: boolean): MessageDescriptor {
  const categoryWithExpenses = category + "_EXPENSES"
  return (
    reimbursementCategoryNameMessages[hasQmeCategory ? categoryWithExpenses : category] ??
    reimbursementCategoryNameMessages[category]
  )
}
